"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConsultingRequest = void 0;
var _assert = require("./assert");
var _createConsultingRequest = require("../../repositories/newbuilding-flat-view-order/v1/create-consulting-request");
const createConsultingRequest = async _ref => {
  let {
    httpApi,
    parameters
  } = _ref;
  const result = await (0, _createConsultingRequest.fetchCreateConsultingRequest)({
    httpApi,
    parameters
  });
  (0, _assert.assertResponseError)(result);
  return result.response;
};
exports.createConsultingRequest = createConsultingRequest;